import { ActionType, Action, locationState } from "../actions/types"

const initialLocationState: locationState = {
  location: "",
  path: "",
  facilityCode: "",
  enableAppBar: true
}

const locationReducer = (
  state: locationState = initialLocationState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_LOCATION:
      return {
        ...state,
        location: action.payload
      }
    case ActionType.SET_PATH:
      return {
        ...state,
        path: action.payload
      }
    case ActionType.SET_FACILITY_CODE:
      return {
        ...state,
        facilityCode: action.payload
      }
    case ActionType.ENABLE_APP_BAR:
      return {
        ...state,
        enableAppBar: action.payload
      }
    default:
      return state
  }
}

export default locationReducer
